import React from 'react';
import PropTypes from 'prop-types';

import {MarketplaceProduct, MarketplaceCollection} from '../components/Marketplace';
import Api from '../Api';

import './RecommendationGrid.less';

const refName = 'recommendation-grid';

export default class RecommendationGrid extends React.Component {
  static propTypes = {
    products: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
    brands: PropTypes.object.isRequired,
    display_order: PropTypes.array.isRequired,
    retailerToken: PropTypes.string.isRequired,
    selectProduct: PropTypes.func,
    generateProductUrl: PropTypes.func.isRequired,
    generateCollectionUrl: PropTypes.func,
    selectCollection: PropTypes.func,
    minimizedTileView: PropTypes.bool
  };

  static defaultProps = {
    minimizedTileView: false,
  };

  constructor(props) {
    super(props);

    this.cartUpdated = this.cartUpdated.bind(this);

    this.state = {
      user: null,
      cart: Api.cache.getCart()
    };
  }

  componentWillMount() {
    Api.getUser(true).then(
      (user) => {
        this.setState({user: user});
      }
    );

    Api.cache.addChangeListener(this.cartUpdated, Api.cache.eventTypes.CART_CHANGED);
  }

  componentWillUnmount() {
    Api.cache.removeChangeListener(this.cartUpdated, Api.cache.eventTypes.CART_CHANGED);
  }

  cartUpdated() {
    this.setState({ cart: Api.cache.getCart() });
  }

  render() {
    let recommendations = null;
    let gridCount = 0;
    let isEmployee = this.state.user && this.state.user.is_employee;

    let display_order = this.props.display_order;
    if (!display_order) return null;

    if (display_order && display_order.length > 0) {
      gridCount = display_order.length;
      recommendations = display_order.map(marketplaceObject => {
        let object = this.props.products[marketplaceObject] || this.props.collections[marketplaceObject];
        if (!object) {
          console.error('invalid display object: %s', marketplaceObject);
          return null;
        }
        if (object.items && object.items.length <= 0) {
          console.error('product collection has no items: %s', marketplaceObject);
          return null;
        }
        let brandToken = object.items ? object.items[0].brand_token : object.brand_token;
        let brand = this.props.brands[brandToken];
        if (!brand) {
          console.error('cannot find brand: "%s"', brandToken);
          console.error(marketplaceObject);
          console.error(object);
          return(null);
        }

        let extra = {};
        if (brand) {
          extra.brand = brand;
        }

        if (object.items) {
          return (
            <MarketplaceCollection
              key={object.token}
              retailerToken={this.props.retailerToken}
              isEmployee={isEmployee}
              onImageLoad={this.fixLayout}
              product={object}
              productList={this.props.products}
              generateProductUrl={this.props.generateCollectionUrl}
              {...extra}
              />
          );
        }

        let cartEntry = null;
        if (this.state.cart && this.state.cart.cart && this.state.cart.cart.items && this.state.cart.cart.items.length > 0) {
          cartEntry = this.state.cart.cart.items.filter(cartItem => {
            return cartItem.product_token === object.token;
          });

          if (cartEntry.length === 0) cartEntry = null;
        }

        return (
          <MarketplaceProduct
            key={object.token}
            retailerToken={this.props.retailerToken}
            isEmployee={isEmployee}
            onImageLoad={this.fixLayout}
            product={object}
            brand={brand}
            minimize={this.props.minimizedTileView}
            generateProductUrl={this.props.generateProductUrl}
            cartEntry={cartEntry}
          />
        );
      });
    }

    return (
      <div className='recommendation-grid-wrapper'>
        <div className={`recommendation-grid grid-count-${gridCount}`}
             ref={refName}>{recommendations}</div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/RecommendationGrid.js
 **/